__turbopack_context__.v({
  "cellTitle": "Agreements-module__TeppYq__cellTitle",
  "container": "Agreements-module__TeppYq__container",
  "editGridCell": "Agreements-module__TeppYq__editGridCell",
  "gridContainer": "Agreements-module__TeppYq__gridContainer",
  "header": "Agreements-module__TeppYq__header",
  "infoGridCell": "Agreements-module__TeppYq__infoGridCell",
  "infoSection": "Agreements-module__TeppYq__infoSection",
});
